import { CATEGORIES, type Category } from '@jemmi/schemas';

import { cn } from '@/lib/cn';

/**
 * "All" is a UI-only filter value, not a real category. We model the active
 * filter as `Category | 'All'` and translate at the boundary when filtering.
 */
export type CategoryFilter = Category | 'All';

const FILTERS: readonly CategoryFilter[] = ['All', ...CATEGORIES] as const;

type Props = {
  active: CategoryFilter;
  onChange: (next: CategoryFilter) => void;
};

export function CategoryPills({ active, onChange }: Props) {
  return (
    <div
      className="scrollbar-hide -mx-4 flex gap-2 overflow-x-auto px-4 pb-2"
      role="tablist"
      aria-label="Filter challenges by category"
    >
      {FILTERS.map((c) => {
        const isActive = c === active;
        return (
          <button
            key={c}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(c)}
            className={cn(
              'shrink-0 rounded-full px-4 py-1.5 text-sm font-medium transition-colors',
              isActive
                ? 'bg-brand-600 text-white shadow-brand-sm'
                : 'bg-slate-100 text-slate-700 hover:bg-slate-200',
            )}
          >
            {c}
          </button>
        );
      })}
    </div>
  );
}
